import { previewDetailsV2 } from "@/api/configPage";
import { useQuery } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

const useFetchConfigPageForVip = ({
  pageCode,
  versionCode,
  previewType,
  shareUid,
  enabled = true,
}: {
  pageCode?: string;
  versionCode?: string;
  previewType?: string;
  shareUid?: string;
  enabled?: boolean;
}) => {
  const query = useQuery({
    queryKey: ["charge/marketingH5Page/findPageConfig@VipHome"],
    queryFn: async () => {
      try {
        const [res1, res2, res3] = await Promise.all([
          pageCode
            ? previewDetailsV2({
                pageCode: pageCode,
                versionCode,
                previewType,
                shareUid,
              })
            : null,
          previewDetailsV2({
            pageCode: "PAGE_MEMBER_ACT",
            versionCode,
            previewType,
            shareUid,
          }),
          previewDetailsV2({
            pageCode: "PAGE_MEMBER",
            versionCode,
            previewType,
            shareUid,
          }),
        ]);
        console.log("PAGE_MEMBER_ACT", res1);
        console.log("PAGE_MEMBER", res2);
        console.log("PAGE_MEMBER", res3);
        // 优先返回有 moduleList 的 res.data
        const list = [res1, res2, res3];
        for (const item of list) {
          if (item?.data?.moduleList?.length) {
            return item.data;
          }
        }
        
        Sentry.captureException(new Error('会员首页未命中任何有效 page config'), {
          tags: {
            error_type: 'vipHomeFindPageConfig_no_valid_data',
            biz: 'charge-vip',
          },
        });
        return null;
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            error_type: 'vipHomeFindPageConfig_exception',
            biz: 'charge-vip',
          },
        });
        return null;
      }
    },
    refetchOnMount: false,
    enabled,
  });

  return query;
};

export default useFetchConfigPageForVip;
